import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Created with ♥ by <b><a href="https://batterypool.com/" target="_blank">BatteryPool</a></b> 2019</span>
  `,
})
export class FooterComponent {
}
